import { Col } from "antd";
import styled from "styled-components";

export const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ReportWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  flex-wrap: wrap;
`;

export const FromGroupSpan = styled.div`
  font-size: 15px;
`;

export const SearchInputCol = styled.div`
  min-width: 250px;
  padding: 0 !important;
`;

export const DropdownSelectCol = styled(Col)`
  @media (max-width: 776px) {
    margin-top: 10px;
  }
`;
